import { Modal, Select, Dropdown, Menu } from "antd";
import { EditOutlined, DeleteOutlined, EllipsisOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { API_URL, TOKEN } from "../../../variables/constants";
import SideBar from "../../../components/SideBar";
import NavBar from "../../../components/NavBar";
import Footer from "../../../components/Footer";
import axiosInstance from "../../../variables/api/axiosInstance";

const AddLieu = () => {
  // --- Visibilité des Modales pour l'ajout/modification ---
  const [openAddRegionModal, setOpenAddRegionModal] = useState(false);
  const [openAddPrefectureModal, setOpenAddPrefectureModal] = useState(false);
  const [openAddCommuneModal, setOpenAddCommuneModal] = useState(false);
  const [openAddQuartierModal, setOpenAddQuartierModal] = useState(false);

  // --- États pour le mode édition et l'objet sélectionné ---
  const [editModeRegion, setEditModeRegion] = useState(false);
  const [editModePrefecture, setEditModePrefecture] = useState(false);
  const [editModeCommune, setEditModeCommune] = useState(false);
  const [editModeQuartier, setEditModeQuartier] = useState(false);
  
  // CET OBJET EST CRUCIAL : il doit contenir TOUTES les propriétés de l'élément sélectionné
  // y compris parametreId, createdAt, createdBy, etc., que le backend attend.
  const [parametreToEdit, setParametreToEdit] = useState(null);

  // --- Valeurs des champs pour les modales d'édition (individuelles) ---
  const [nomRegion, setNomRegion] = useState("");
  const [nomPrefectureEdit, setNomPrefectureEdit] = useState("");
  const [nomCommuneEdit, setNomCommuneEdit] = useState("");
  const [nomQuartierEdit, setNomQuartierEdit] = useState("");

  // --- Listes de données récupérées du backend ---
  const [regions, setRegions] = useState([]);
  const [prefectures, setPrefectures] = useState([]);
  const [communes, setCommunes] = useState([]);
  const [quartiers, setQuartiers] = useState([]);

  // --- Nouveaux éléments à ajouter via les sélecteurs "tags" ---
  const [nouvellesPrefectures, setNouvellesPrefectures] = useState([]);
  const [nouvellesCommunes, setNouvellesCommunes] = useState([]);
  const [nouveauxQuartiers, setNouveauxQuartiers] = useState([]);

  // --- Effet de chargement initial des données ---
  useEffect(() => {
    fetchRegions();
    fetchPrefectures();
    fetchCommunes();
    fetchQuartiers();
  }, []);

  // --- Fonctions de récupération des données ---
  const fetchRegions = () => {
    axiosInstance
      .get(`/api/parametre/type/REGION`)
      .then((res) => {
        setRegions(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération des régions:", err);
        setRegions([]);
      });
  };

  const fetchPrefectures = () => {
    axiosInstance
      .get(`/api/parametre/type/PREFECTURE`)
      .then((res) => {
        setPrefectures(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération des préfectures:", err);
        setPrefectures([]);
      });
  };

  const fetchCommunes = () => {
    axiosInstance
      .get(`/api/parametre/type/COMMUNE`)
      .then((res) => {
        setCommunes(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération des communes:", err);
        setCommunes([]);
      });
  };

  const fetchQuartiers = () => {
    axiosInstance
      .get(`/api/parametre/type/QUARTIER`)
      .then((res) => {
        setQuartiers(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération des quartiers:", err);
        setQuartiers([]);
      });
  };

  // --- Fonctions de vérification des doublons (utilisent parametreId) ---
  const checkDuplicateRegion = (name, currentId = null) => {
    return Array.isArray(regions) && regions.some(
      (region) =>
        region.libelleParametre.toLowerCase() === name.toLowerCase() &&
        region.parametreId !== currentId
    );
  };

  const checkDuplicatePrefecture = (name, regionValue, currentId = null) => {
    return Array.isArray(prefectures) && prefectures.some(
      (pref) =>
        pref.libelleParametre.toLowerCase() === name.toLowerCase() &&
        pref.valeur === regionValue &&
        pref.parametreId !== currentId
    );
  };

  const checkDuplicateCommune = (name, prefectureValue, currentId = null) => {
    return Array.isArray(communes) && communes.some(
      (com) =>
        com.libelleParametre.toLowerCase() === name.toLowerCase() &&
        com.valeur === prefectureValue &&
        com.parametreId !== currentId
    );
  };

  const checkDuplicateQuartier = (name, communeValue, currentId = null) => {
    return Array.isArray(quartiers) && quartiers.some(
      (quart) =>
        quart.libelleParametre.toLowerCase() === name.toLowerCase() &&
        quart.valeur === communeValue &&
        quart.parametreId !== currentId
    );
  };

  // --- Gérer la Modification (centralisé pour tous les types) ---
  const handleEditParametre = (parametre) => {
    if (!parametre || parametre.parametreId === undefined || parametre.parametreId === null) {
      toast.error("Impossible de modifier : ID de l'élément manquant ou invalide.");
      console.error("Tentative de modification sans ID valide:", parametre);
      return;
    }

    setParametreToEdit(parametre);

    if (parametre.typeParametre === "REGION") {
      setEditModeRegion(true);
      setNomRegion(parametre.libelleParametre);
      setOpenAddRegionModal(true);
    } else if (parametre.typeParametre === "PREFECTURE") {
      setEditModePrefecture(true);
      setNomPrefectureEdit(parametre.libelleParametre);
      setOpenAddPrefectureModal(true);
    } else if (parametre.typeParametre === "COMMUNE") {
      setEditModeCommune(true);
      setNomCommuneEdit(parametre.libelleParametre);
      setOpenAddCommuneModal(true);
    } else if (parametre.typeParametre === "QUARTIER") {
      setEditModeQuartier(true);
      setNomQuartierEdit(parametre.libelleParametre);
      setOpenAddQuartierModal(true);
    }
  };

  // --- Gérer la Suppression ---
  const handleDeleteParametre = (id) => {
    if (id === undefined || id === null || isNaN(Number(id))) {
      toast.error("Impossible de supprimer : ID de l'élément manquant ou invalide.");
      console.error("Tentative de suppression sans ID valide:", id);
      return;
    }

    if (window.confirm("Êtes-vous sûr de vouloir supprimer cet élément ?")) {
      axiosInstance
        .delete(`/api/parametre/${id}`)
        .then(() => {
          toast.success("Suppression réussie");
          fetchRegions();
          fetchPrefectures();
          fetchCommunes();
          fetchQuartiers();
        })
        .catch((err) => {
          console.error("Erreur lors de la suppression:", err);
          toast.error("Erreur lors de la suppression.");
        });
    }
  };

  // --- Gérer les Opérations sur les Régions ---
  const handleAddRegion = () => {
    if (!nomRegion || nomRegion.length < 3) {
      toast.error("Veuillez renseigner un nom de région valide (au moins 3 caractères).");
      return;
    }

    const currentRegionId = editModeRegion && parametreToEdit ? parametreToEdit.parametreId : null;
    if (checkDuplicateRegion(nomRegion, currentRegionId)) {
        toast.error("Cette région existe déjà.");
        return;
    }

    if (editModeRegion && parametreToEdit) {
        const updatedRegion = {
            ...parametreToEdit, // Copie toutes les propriétés existantes (ID, createdAt, createdBy, etc.)
            libelleParametre: nomRegion, // Met à jour le libellé
            valeur: nomRegion, // Pour la région, la valeur est souvent son propre libellé
            typeParametre: "REGION", 
        };

        // --- CHANGEMENT CLÉ ICI : Pas d'ID dans l'URL pour PUT ---
        axiosInstance
            .put(`/api/parametre`, updatedRegion) // L'ID est dans le corps de `updatedRegion`
            .then((res) => {
                toast.success("Région modifiée avec succès");
                setOpenAddRegionModal(false);
                setEditModeRegion(false);
                setParametreToEdit(null);
                setNomRegion("");
                fetchRegions();
            })
            .catch((err) => {
                console.error("Erreur lors de la modification de la région:", err.response ? err.response.data : err.message);
                toast.error("Erreur lors de la modification de la région.");
            });
    } else {
      // Pour l'AJOUT (inchangé)
      const parametrePayload = {
        libelleParametre: nomRegion,
        valeur: nomRegion,
        typeParametre: "REGION",
      };
      axiosInstance
        .post(`/api/parametre`, parametrePayload)
        .then((res) => {
          toast.success("Région ajoutée avec succès");
          setOpenAddRegionModal(false);
          setNomRegion("");
          fetchRegions();
        })
        .catch((err) => {
          console.error("Erreur lors de l'ajout de la région:", err.response ? err.response.data : err.message);
          toast.error("Erreur lors de l'ajout de la région.");
        });
    }
  };

  // --- Gérer les Opérations sur les Préfectures (Ajout Multiple) ---
  const handleSelectChangePrefecture = (value, regionValue) => {
    const newPrefecturesForRegion = value.map(item => ({
      valeur: regionValue,
      libelleParametre: item,
      typeParametre: "PREFECTURE",
    }));

    const filteredNewPrefectures = newPrefecturesForRegion.filter(newPref =>
      !prefectures.some(existingPref =>
        existingPref.libelleParametre.toLowerCase() === newPref.libelleParametre.toLowerCase() &&
        existingPref.valeur === newPref.valeur
      )
    );

    setNouvellesPrefectures(prev => {
        const otherRegionsPrefectures = prev.filter(p => p.valeur !== regionValue);
        return [...otherRegionsPrefectures, ...filteredNewPrefectures];
    });
  };

  const handleAddPrefectures = () => {
    if (nouvellesPrefectures.length < 1) {
      toast.error("Aucune nouvelle préfecture à ajouter.");
      return;
    }

    const prefsToAdd = [];
    nouvellesPrefectures.forEach((pref) => {
      if (!checkDuplicatePrefecture(pref.libelleParametre, pref.valeur)) {
        prefsToAdd.push(pref);
      } else {
        toast.warn(`La préfecture '${pref.libelleParametre}' existe déjà dans la région '${pref.valeur}'.`);
      }
    });

    if (prefsToAdd.length === 0) {
      toast.info("Toutes les préfectures sélectionnées existent déjà ou sont invalides.");
      return;
    }

    axiosInstance
      .post(`/api/parametre/all`, JSON.stringify(prefsToAdd), {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        toast.success("Préfecture(s) ajoutée(s) avec succès");
        setNouvellesPrefectures([]);
        fetchPrefectures();
      })
      .catch((err) => {
        console.error("Erreur lors de l'ajout des préfectures:", err.response ? err.response.data : err.message);
        toast.error("Erreur lors de l'ajout des préfectures.");
      });
  };

  // Fonction pour la MODIFICATION INDIVIDUELLE d'une Préfecture
  const handleUpdatePrefecture = () => {
    if (!nomPrefectureEdit || nomPrefectureEdit.length < 3) {
      toast.error("Veuillez renseigner un nom de préfecture valide (au moins 3 caractères).");
      return;
    }

    if (!parametreToEdit || parametreToEdit.parametreId === undefined || parametreToEdit.parametreId === null) {
      toast.error("Impossible de modifier : ID de la préfecture manquant.");
      return;
    }

    if (checkDuplicatePrefecture(nomPrefectureEdit, parametreToEdit.valeur, parametreToEdit.parametreId)) {
      toast.error("Une autre préfecture porte déjà ce nom dans cette région.");
      return;
    }

    const updatedParametre = {
      ...parametreToEdit, // Copie toutes les propriétés existantes (y compris parametreId)
      libelleParametre: nomPrefectureEdit,
      typeParametre: "PREFECTURE",
    };

    // --- CHANGEMENT CLÉ ICI : Pas d'ID dans l'URL pour PUT ---
    axiosInstance
      .put(`/api/parametre`, updatedParametre) // L'ID est dans le corps de `updatedParametre`
      .then((res) => {
        toast.success("Préfecture modifiée avec succès");
        setOpenAddPrefectureModal(false);
        setEditModePrefecture(false);
        setParametreToEdit(null);
        setNomPrefectureEdit("");
        fetchPrefectures();
      })
      .catch((err) => {
        console.error("Erreur lors de la modification de la préfecture:", err.response ? err.response.data : err.message);
        toast.error("Erreur lors de la modification de la préfecture.");
      });
  };


  // --- Gérer les Opérations sur les Communes (Ajout Multiple) ---
  const handleSelectChangeCommune = (value, prefectureValue) => {
    const newCommunesForPrefecture = value.map(item => ({
      valeur: prefectureValue,
      libelleParametre: item,
      typeParametre: "COMMUNE",
    }));

    const filteredNewCommunes = newCommunesForPrefecture.filter(newCom =>
      !communes.some(existingCom =>
        existingCom.libelleParametre.toLowerCase() === newCom.libelleParametre.toLowerCase() &&
        existingCom.valeur === newCom.valeur
      )
    );

    setNouvellesCommunes(prev => {
        const otherPrefecturesCommunes = prev.filter(c => c.valeur !== prefectureValue);
        return [...otherPrefecturesCommunes, ...filteredNewCommunes];
    });
  };

  const handleAddCommunes = () => {
    if (nouvellesCommunes.length < 1) {
      toast.error("Aucune nouvelle commune à ajouter.");
      return;
    }

    const communesToAdd = [];
    nouvellesCommunes.forEach((com) => {
      if (!checkDuplicateCommune(com.libelleParametre, com.valeur)) {
        communesToAdd.push(com);
      } else {
        toast.warn(`La commune '${com.libelleParametre}' existe déjà dans la préfecture '${com.valeur}'.`);
      }
    });

    if (communesToAdd.length === 0) {
      toast.info("Toutes les communes sélectionnées existent déjà ou sont invalides.");
      return;
    }

    axiosInstance
      .post(`/api/parametre/all`, JSON.stringify(communesToAdd), {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        toast.success("Commune(s) ajoutée(s) avec succès");
        setNouvellesCommunes([]);
        fetchCommunes();
      })
      .catch((err) => {
        console.error("Erreur lors de l'ajout des communes:", err.response ? err.response.data : err.message);
        toast.error("Erreur lors de l'ajout des communes.");
      });
  };

  // Fonction pour la MODIFICATION INDIVIDUELLE d'une Commune
  const handleUpdateCommune = () => {
    if (!nomCommuneEdit || nomCommuneEdit.length < 3) {
      toast.error("Veuillez renseigner un nom de commune valide (au moins 3 caractères).");
      return;
    }

    if (!parametreToEdit || parametreToEdit.parametreId === undefined || parametreToEdit.parametreId === null) {
      toast.error("Impossible de modifier : ID de la commune manquant.");
      return;
    }

    if (checkDuplicateCommune(nomCommuneEdit, parametreToEdit.valeur, parametreToEdit.parametreId)) {
      toast.error("Une autre commune porte déjà ce nom dans cette préfecture.");
      return;
    }

    const updatedParametre = {
      ...parametreToEdit, // Copie toutes les propriétés existantes (y compris parametreId)
      libelleParametre: nomCommuneEdit,
      typeParametre: "COMMUNE",
    };

    // --- CHANGEMENT CLÉ ICI : Pas d'ID dans l'URL pour PUT ---
    axiosInstance
      .put(`/api/parametre`, updatedParametre) // L'ID est dans le corps de `updatedParametre`
      .then((res) => {
        toast.success("Commune modifiée avec succès");
        setOpenAddCommuneModal(false);
        setEditModeCommune(false);
        setParametreToEdit(null);
        setNomCommuneEdit("");
        fetchCommunes();
      })
      .catch((err) => {
        console.error("Erreur lors de la modification de la commune:", err.response ? err.response.data : err.message);
        toast.error("Erreur lors de la modification de la commune.");
      });
  };

  // --- Gérer les Opérations sur les Quartiers (Ajout Multiple) ---
  const handleSelectChangeQuartier = (value, communeValue) => {
    const newQuartiersForCommune = value.map(item => ({
      valeur: communeValue,
      libelleParametre: item,
      typeParametre: "QUARTIER",
    }));

    const filteredNewQuartiers = newQuartiersForCommune.filter(newQuart =>
      Array.isArray(quartiers) && !quartiers.some(existingQuart =>
        existingQuart.libelleParametre.toLowerCase() === newQuart.libelleParametre.toLowerCase() &&
        existingQuart.valeur === newQuart.valeur
      )
    );

    setNouveauxQuartiers(prev => {
        const otherCommunesQuartiers = prev.filter(q => q.valeur !== communeValue);
        return [...otherCommunesQuartiers, ...filteredNewQuartiers];
    });
  };

  const handleAddQuartiers = () => {
    if (nouveauxQuartiers.length < 1) {
      toast.error("Aucun nouveau quartier à ajouter.");
      return;
    }

    const quartiersToAdd = [];
    nouveauxQuartiers.forEach((quart) => {
      if (!checkDuplicateQuartier(quart.libelleParametre, quart.valeur)) {
        quartiersToAdd.push(quart);
      } else {
        toast.warn(`Le quartier '${quart.libelleParametre}' existe déjà dans la commune '${quart.valeur}'.`);
      }
    });

    if (quartiersToAdd.length === 0) {
      toast.info("Toutes les quartiers sélectionnés existent déjà ou sont invalides.");
      return;
    }

    axiosInstance
      .post(`/api/parametre/all`, JSON.stringify(quartiersToAdd), {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        toast.success("Quartier(s) ajouté(s) avec succès");
        setNouveauxQuartiers([]);
        fetchQuartiers();
      })
      .catch((err) => {
        console.error("Erreur lors de l'ajout des quartiers:", err.response ? err.response.data : err.message);
        toast.error("Erreur lors de l'ajout des quartiers.");
      });
  };

  // Fonction pour la MODIFICATION INDIVIDUELLE d'un Quartier
  const handleUpdateQuartier = () => {
    if (!nomQuartierEdit || nomQuartierEdit.length < 3) {
      toast.error("Veuillez renseigner un nom de quartier valide (au moins 3 caractères).");
      return;
    }

    if (!parametreToEdit || parametreToEdit.parametreId === undefined || parametreToEdit.parametreId === null) {
      toast.error("Impossible de modifier : ID du quartier manquant.");
      return;
    }

    if (checkDuplicateQuartier(nomQuartierEdit, parametreToEdit.valeur, parametreToEdit.parametreId)) {
      toast.error("Un autre quartier porte déjà ce nom dans cette commune.");
      return;
    }

    const updatedParametre = {
      ...parametreToEdit, // Copie toutes les propriétés existantes (y compris parametreId)
      libelleParametre: nomQuartierEdit,
      typeParametre: "QUARTIER",
    };

    // --- CHANGEMENT CLÉ ICI : Pas d'ID dans l'URL pour PUT ---
    axiosInstance
      .put(`/api/parametre`, updatedParametre) // L'ID est dans le corps de `updatedParametre`
      .then((res) => {
        toast.success("Quartier modifié avec succès");
        setOpenAddQuartierModal(false);
        setEditModeQuartier(false);
        setParametreToEdit(null);
        setNomQuartierEdit("");
        fetchQuartiers();
      })
      .catch((err) => {
        console.error("Erreur lors de la modification du quartier:", err.response ? err.response.data : err.message);
        toast.error("Erreur lors de la modification du quartier.");
      });
  };

  // --- Fonctions utilitaires pour les options des sélecteurs Ant Design ---
  const getPrefecturesOfRegions = (regionValue) => {
    return Array.isArray(prefectures) ? prefectures
      .filter((e) => e.valeur === regionValue)
      .map((pref) => ({
        label: pref.libelleParametre,
        value: pref.libelleParametre,
      })) : [];
  };

  const getCommunesOfPrefectures = (prefectureValue) => {
    return Array.isArray(communes) ? communes
      .filter((e) => e.valeur === prefectureValue)
      .map((com) => ({
        label: com.libelleParametre,
        value: com.libelleParametre,
      })) : [];
  };

  const getQuartiersOfCommunes = (communeValue) => {
    return Array.isArray(quartiers) ? quartiers
      .filter((e) => e.valeur === communeValue)
      .map((quart) => ({
        label: quart.libelleParametre,
        value: quart.libelleParametre,
      })) : [];
  };

  // --- Fonction pour créer le Menu Dropdown d'Ant Design (Adapté pour 'menu' prop) ---
  const createDropdownMenuItems = (item) => ({
    items: [
      {
        key: 'edit',
        label: (
          <>
            <EditOutlined /> Modifier
          </>
        ),
        onClick: () => handleEditParametre(item), // Passe l'objet complet `item`
      },
      {
        key: 'delete',
        label: (
          <>
            <DeleteOutlined /> Supprimer
          </>
        ),
        danger: true,
        onClick: () => handleDeleteParametre(item.parametreId), // Passe `item.parametreId`
      },
    ],
  });

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu={"PARAMETRES"} />

        <div className="layout-page">
          <NavBar />

          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row">
                <div className="row my-6">
                  <div className="col">
                    <h6>Paramétrage de lieu</h6>
                    <div className="accordion" id="collapsibleSection">
                      {/* --- Section Régions --- */}
                      <div className="card accordion-item">
                        <h2 className="accordion-header" id="headingRegions">
                          <button
                            type="button"
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseRegions"
                            aria-expanded="true"
                            aria-controls="collapseRegions"
                          >
                            Régions
                          </button>
                        </h2>
                        <div
                          id="collapseRegions"
                          className="accordion-collapse collapse show"
                          data-bs-parent="#collapsibleSection"
                        >
                          <div className="accordion-body">
                            <div className="row g-6">
                              <div className="col-12 mb-3">
                                <button
                                  onClick={() => {
                                    setEditModeRegion(false);
                                    setParametreToEdit(null);
                                    setNomRegion("");
                                    setOpenAddRegionModal(true);
                                  }}
                                  className="btn btn-primary"
                                >
                                  Ajouter une Région
                                </button>
                              </div>
                              <div className="col-12">
                                <div className="card">
                                  <div className="table-responsive text-nowrap">
                                    <table className="table">
                                      <thead>
                                        <tr className="text-nowrap">
                                          <th>#</th>
                                          <th>Nom</th>
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody className="table-border-bottom-0">
                                        {regions && regions.length > 0 ? (
                                          regions.map((region, index) => (
                                            <tr key={region.parametreId}>
                                              <th>{index + 1}</th>
                                              <td>{region.libelleParametre}</td>
                                              <td>
                                                <Dropdown
                                                  menu={createDropdownMenuItems(region)} // Utilisation de 'menu'
                                                  trigger={['click']}
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn p-0"
                                                  >
                                                    <EllipsisOutlined />
                                                  </button>
                                                </Dropdown>
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="3" className="text-center">Aucune région disponible</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Modal
                          title={editModeRegion ? "Modifier la Région" : "Ajouter une Région"}
                          open={openAddRegionModal}
                          onCancel={() => {
                            setOpenAddRegionModal(false);
                            setEditModeRegion(false);
                            setParametreToEdit(null);
                            setNomRegion("");
                          }}
                          onOk={handleAddRegion}
                          okText={editModeRegion ? "Modifier" : "Ajouter"}
                          cancelText={"Annuler"}
                        >
                          <div className="mb-6">
                            <label className="form-label" htmlFor="nomRegion">
                              Nom de la région
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="nomRegion"
                              placeholder="Nom de la région"
                              value={nomRegion}
                              onChange={(e) => setNomRegion(e.target.value)}
                            />
                          </div>
                        </Modal>
                      </div>

                      {/* --- Section Préfectures --- */}
                      <div className="card accordion-item">
                        <h2 className="accordion-header" id="headingPrefectures">
                          <button
                            type="button"
                            className="accordion-button collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsePrefectures"
                            aria-expanded="false"
                            aria-controls="collapsePrefectures"
                          >
                            Préfectures
                          </button>
                        </h2>
                        <div
                          id="collapsePrefectures"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingPrefectures"
                          data-bs-parent="#collapsibleSection"
                        >
                          <div className="accordion-body">
                            <div className="row g-6">
                              {regions && regions.length > 0 ? regions.map((region) => (
                                <div
                                  className="col-md-12 select2-primary mb-3"
                                  key={region.parametreId}
                                >
                                  <label
                                    className="form-label"
                                    htmlFor={`prefecture-select-${region.parametreId}`}
                                  >
                                    Préfectures de {region?.libelleParametre}
                                  </label>
                                  <Select
                                    mode="tags"
                                    style={{ width: "100%" }}
                                    placeholder="Veuillez sélectionner ou ajouter les préfectures"
                                    onChange={(value) =>
                                      handleSelectChangePrefecture(value, region?.valeur)
                                    }
                                    options={getPrefecturesOfRegions(region?.valeur)}
                                    // defaultValue doit être géré avec soin pour les tags
                                    defaultValue={getPrefecturesOfRegions(region?.valeur).map(opt => opt.value)}
                                  />
                                </div>
                              )) : (
                                <div className="col-12 text-center">Veuillez ajouter des régions d'abord.</div>
                              )}
                              <div className="col-12 mt-3">
                                <button
                                  onClick={handleAddPrefectures}
                                  className="btn btn-primary"
                                >
                                  Ajouter / Mettre à jour les préfectures (via sélection)
                                </button>
                              </div>

                              <div className="col-12 mt-4">
                                <div className="card">
                                  <div className="table-responsive text-nowrap">
                                    <table className="table">
                                      <thead>
                                        <tr className="text-nowrap">
                                          <th>#</th>
                                          <th>Nom</th>
                                          <th>Région</th>
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody className="table-border-bottom-0">
                                        {prefectures && prefectures.length > 0 ? (
                                          prefectures.map((pref, index) => (
                                            <tr key={pref.parametreId}>
                                              <th>{index + 1}</th>
                                              <td>{pref.libelleParametre}</td>
                                              <td>{pref.valeur}</td>
                                              <td>
                                                <Dropdown
                                                  menu={createDropdownMenuItems(pref)} // Utilisation de 'menu'
                                                  trigger={['click']}
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn p-0"
                                                  >
                                                    <EllipsisOutlined />
                                                  </button>
                                                </Dropdown>
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="4" className="text-center">Aucune préfecture disponible</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Modale pour la modification individuelle d'une Préfecture */}
                        <Modal
                          title={"Modifier la Préfecture"}
                          open={openAddPrefectureModal}
                          onCancel={() => {
                            setOpenAddPrefectureModal(false);
                            setEditModePrefecture(false);
                            setParametreToEdit(null);
                            setNomPrefectureEdit("");
                          }}
                          onOk={handleUpdatePrefecture}
                          okText={"Modifier"}
                          cancelText={"Annuler"}
                        >
                          <div className="mb-6">
                            <label className="form-label" htmlFor="nomPrefectureEdit">
                              Nom de la préfecture
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="nomPrefectureEdit"
                              placeholder="Nom de la préfecture"
                              value={nomPrefectureEdit}
                              onChange={(e) => setNomPrefectureEdit(e.target.value)}
                            />
                            {parametreToEdit && parametreToEdit.valeur && (
                                <small className="text-muted mt-2">Région associée : {parametreToEdit.valeur}</small>
                            )}
                          </div>
                        </Modal>
                      </div>

                      {/* --- Section Communes --- */}
                      <div className="card accordion-item">
                        <h2 className="accordion-header" id="headingCommunes">
                          <button
                            type="button"
                            className="accordion-button collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseCommunes"
                            aria-expanded="false"
                            aria-controls="collapseCommunes"
                          >
                            Communes / Ville / Village
                          </button>
                        </h2>
                        <div
                          id="collapseCommunes"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingCommunes"
                          data-bs-parent="#collapsibleSection"
                        >
                          <div className="accordion-body">
                            <div className="row g-6">
                              {prefectures && prefectures.length > 0 ? prefectures.map((pref) => (
                                <div
                                  className="col-md-12 select2-primary mb-3"
                                  key={pref.parametreId}
                                >
                                  <label
                                    className="form-label"
                                    htmlFor={`commune-select-${pref.parametreId}`}
                                  >
                                    Communes de {pref?.libelleParametre}
                                  </label>
                                  <Select
                                    mode="tags"
                                    style={{ width: "100%" }}
                                    placeholder="Veuillez sélectionner ou ajouter les villes / communes / villages"
                                    onChange={(value) =>
                                      handleSelectChangeCommune(value, pref?.libelleParametre)
                                    }
                                    options={getCommunesOfPrefectures(pref?.libelleParametre)}
                                    defaultValue={getCommunesOfPrefectures(pref?.libelleParametre).map(opt => opt.value)}
                                  />
                                </div>
                              )) : (
                                <div className="col-12 text-center">Veuillez ajouter des préfectures d'abord.</div>
                              )}
                              <div className="col-12 mt-3">
                                <button
                                  onClick={handleAddCommunes}
                                  className="btn btn-primary"
                                >
                                  Ajouter / Mettre à jour les communes (via sélection)
                                </button>
                              </div>

                              <div className="col-12 mt-4">
                                <div className="card">
                                  <div className="table-responsive text-nowrap">
                                    <table className="table">
                                      <thead>
                                        <tr className="text-nowrap">
                                          <th>#</th>
                                          <th>Nom</th>
                                          <th>Préfecture</th>
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody className="table-border-bottom-0">
                                        {communes && communes.length > 0 ? (
                                          communes.map((com, index) => (
                                            <tr key={com.parametreId}>
                                              <th>{index + 1}</th>
                                              <td>{com.libelleParametre}</td>
                                              <td>{com.valeur}</td>
                                              <td>
                                                <Dropdown
                                                  menu={createDropdownMenuItems(com)} // Utilisation de 'menu'
                                                  trigger={['click']}
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn p-0"
                                                  >
                                                    <EllipsisOutlined />
                                                  </button>
                                                </Dropdown>
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="4" className="text-center">Aucune commune disponible</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Modale pour la modification individuelle d'une Commune */}
                        <Modal
                          title={"Modifier la Commune"}
                          open={openAddCommuneModal}
                          onCancel={() => {
                            setOpenAddCommuneModal(false);
                            setEditModeCommune(false);
                            setParametreToEdit(null);
                            setNomCommuneEdit("");
                          }}
                          onOk={handleUpdateCommune}
                          okText={"Modifier"}
                          cancelText={"Annuler"}
                        >
                          <div className="mb-6">
                            <label className="form-label" htmlFor="nomCommuneEdit">
                              Nom de la commune
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="nomCommuneEdit"
                              placeholder="Nom de la commune"
                              value={nomCommuneEdit}
                              onChange={(e) => setNomCommuneEdit(e.target.value)}
                            />
                            {parametreToEdit && parametreToEdit.valeur && (
                                <small className="text-muted mt-2">Préfecture associée : {parametreToEdit.valeur}</small>
                            )}
                          </div>
                        </Modal>
                      </div>

                      {/* --- Section Quartiers --- */}
                      <div className="card accordion-item">
                        <h2
                          className="accordion-header"
                          id="quartiers"
                        >
                          <button
                            type="button"
                            className="accordion-button collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseQuartiers"
                            aria-expanded="false"
                            aria-controls="collapseQuartiers"
                          >
                            Quartiers
                          </button>
                        </h2>
                        <div
                          id="collapseQuartiers"
                          className="accordion-collapse collapse"
                          aria-labelledby="quartiers"
                          data-bs-parent="#collapsibleSection"
                        >
                          <div className="accordion-body">
                            <div className="row g-6">
                              {communes && communes.length > 0 ? communes?.map((com) => (
                                <div
                                  className="col-md-12 select2-primary mb-3"
                                  key={com.parametreId}
                                >
                                  <label
                                    className="form-label"
                                    htmlFor={`quartier-select-${com.parametreId}`}
                                  >
                                    Quartiers de {com?.libelleParametre}
                                  </label>
                                  <Select
                                    mode="tags"
                                    style={{
                                      width: "100%",
                                    }}
                                    placeholder="Veuillez sélectionner ou ajouter les quartiers"
                                    onChange={(value) =>
                                      handleSelectChangeQuartier(value, com?.libelleParametre)
                                    }
                                    options={getQuartiersOfCommunes(com?.libelleParametre)}
                                    defaultValue={getQuartiersOfCommunes(com?.libelleParametre).map(opt => opt.value)}
                                  />
                                </div>
                              )) : (
                                <div className="col-12 text-center">Veuillez ajouter des communes d'abord pour gérer les quartiers.</div>
                              )}
                              <div className="col-12 mt-3">
                                <button
                                  onClick={handleAddQuartiers}
                                  className="btn btn-primary"
                                >
                                  Ajouter / Mettre à jour les quartiers (via sélection)
                                </button>
                              </div>

                              <div className="col-12 mt-4">
                                <div className="card">
                                  <div className="table-responsive text-nowrap">
                                    <table className="table">
                                      <thead>
                                        <tr className="text-nowrap">
                                          <th>#</th>
                                          <th>Nom</th>
                                          <th>Commune</th>
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody className="table-border-bottom-0">
                                        {quartiers && quartiers.length > 0 ? (
                                          quartiers.map((quart, index) => (
                                            <tr key={quart.parametreId}>
                                              <th>{index + 1}</th>
                                              <td>{quart.libelleParametre}</td>
                                              <td>{quart.valeur}</td>
                                              <td>
                                                <Dropdown
                                                  menu={createDropdownMenuItems(quart)} // Utilisation de 'menu'
                                                  trigger={['click']}
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn p-0"
                                                  >
                                                    <EllipsisOutlined />
                                                  </button>
                                                </Dropdown>
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="4" className="text-center">Aucun quartier disponible</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Modale pour la modification individuelle d'un Quartier */}
                        <Modal
                          title={"Modifier le Quartier"}
                          open={openAddQuartierModal}
                          onCancel={() => {
                            setOpenAddQuartierModal(false);
                            setEditModeQuartier(false);
                            setParametreToEdit(null);
                            setNomQuartierEdit("");
                          }}
                          onOk={handleUpdateQuartier}
                          okText={"Modifier"}
                          cancelText={"Annuler"}
                        >
                          <div className="mb-6">
                            <label className="form-label" htmlFor="nomQuartierEdit">
                              Nom du quartier
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="nomQuartierEdit"
                              placeholder="Nom du quartier"
                              value={nomQuartierEdit}
                              onChange={(e) => setNomQuartierEdit(e.target.value)}
                            />
                            {parametreToEdit && parametreToEdit.valeur && (
                                <small className="text-muted mt-2">Commune associée : {parametreToEdit.valeur}</small>
                            )}
                          </div>
                        </Modal>
                      </div>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />

            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>

      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default AddLieu;